import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "auth-manager" }
const _hoisted_2 = {
  key: 1,
  class: "error-message"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoginScreen = _resolveComponent("LoginScreen")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.isAuthenticated && !_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_LoginScreen, {
          key: 0,
          onLoginSuccess: _ctx.handleLoginSuccess
        }, null, 8, ["onLoginSuccess"]))
      : _createCommentVNode("", true),
    (_ctx.error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createTextVNode(_toDisplayString(_ctx.error) + " ", 1),
          _createVNode(_component_a_button, {
            type: "link",
            onClick: _ctx.clearError
          }, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createTextVNode("閲嶈瘯", -1)
            ]))]),
            _: 1
          }, 8, ["onClick"])
        ]))
      : _createCommentVNode("", true)
  ]))
}